import { useRef } from 'react';
import type { ColorFieldProps, ReactAriaOrHexString } from '@frameio/vapor';
import { ColorField, ColorPicker, Popover } from '@frameio/vapor';
import { IconFiletypeImage } from '@frameio/vapor-icons';
import { theme } from '@frameio/vapor-theme';
import TEXT from './generated/TEXT/ColorSelector';

TEXT.DEFINE({
  /** Label for text color selector */
  label: 'Text color',
});

export const ColorSelector: React.FC<ColorFieldProps> = ({
  isDisabled,
  size = 'medium',
  value,
  onChange,
}) => {
  const popoverColorFieldRef = useRef<HTMLInputElement>(null);

  const handleChange = (newSelectedColor: ReactAriaOrHexString) =>
    onChange?.(newSelectedColor);
  return (
    <ColorField.Root
      isDisabled={isDisabled}
      maxWidth="100%"
      onChange={handleChange}
      size={size}
      style={{ color: theme.colors.text.tertiary }}
      value={value}
    >
      <Popover
        content={
          <ColorPicker.Root onChange={handleChange} value={value}>
            <ColorPicker.ColorArea />
            <ColorPicker.ColorSlider />
            <ColorPicker.ColorField
              ref={popoverColorFieldRef}
              displayLabel={true}
              label={TEXT.label}
              labelIcon={
                <IconFiletypeImage
                  color={theme.colors.text.secondary}
                  size={16}
                />
              }
            />
          </ColorPicker.Root>
        }
        initialFocusRef={
          popoverColorFieldRef as unknown as React.RefObject<HTMLElement>
        }
        placement="right-start"
      >
        <ColorField.Swatch isInteractive={true} />
      </Popover>
    </ColorField.Root>
  );
};
